<ng-template
  [ngTemplateOutlet]="tpl"
  [ngTemplateOutletContext]="{
    data: data,
    instance: snackRef
  }">
</ng-template>
